import React, { useRef, useEffect } from 'react';

const createRootRef = (visible: boolean) => {
  const element = document.createElement('div');
  element.style.position = visible ? 'unset' : 'absolute';
  element.style.height = visible ? 'auto' : '0px';
  element.style.overflow = visible ? 'auto' : 'hidden';

  return element;
};

const usePortal = (id: string, visible: boolean) => {
  const rootElemRef = useRef(createRootRef(visible));

  useEffect(() => {
    const modalRoot = document.getElementById(id);

    if (!modalRoot) {
      const containerDiv = document.createElement('div');
      containerDiv.id = id;
      document.documentElement.appendChild(containerDiv);
    }
  }, [id]);

  useEffect(() => {
    const existingParent = document.getElementById(id);

    // existingParent.appendChild(rootElemRef.current);
    existingParent.replaceChildren(rootElemRef.current);

    return function removeElement() {
      rootElemRef.current.remove();

      if (!existingParent.childElementCount) {
        existingParent.remove();
      }
    };
  }, [id]);

  return rootElemRef.current;
};

export default usePortal;
